

import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { getProfile, logoutUser } from '../api';
import './Dashboard.css';


export default function Dashboard() {
  const [profile, setProfile] = useState(null);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const avatarRef = useRef(null);
  const widgetRef = useRef(null);

  useEffect(() => {
    getProfile()
      .then(setProfile)
      .catch(() => {
        setError('Session expired. Please login again.');
        setTimeout(() => navigate('/login'), 1500);
      });
  }, [navigate]);

  useEffect(() => {
    if (!avatarRef.current) return;
    import('three').then(THREE => {
      const width = 320, height = 260;
      const scene = new THREE.Scene();
      const camera = new THREE.PerspectiveCamera(35, width/height, 0.1, 1000);
      camera.position.set(0, 0, 4);
      const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
      renderer.setSize(width, height);
      renderer.setClearColor(0x0b1020, 0);
      avatarRef.current.innerHTML = '';
      avatarRef.current.appendChild(renderer.domElement);
      // Head
      const headMat = new THREE.MeshStandardMaterial({ color: 0xffd9c0, roughness: 0.8 });
      const headGeo = new THREE.SphereGeometry(1.0, 32, 32);
      const headMesh = new THREE.Mesh(headGeo, headMat);
      headMesh.position.y = 0.1;
      scene.add(headMesh);
      // Jaw
      const jawMat = new THREE.MeshStandardMaterial({ color: 0xeaa79a, roughness: 0.9 });
      const jawGeo = new THREE.BoxGeometry(1.1, 0.3, 0.9);
      const jaw = new THREE.Mesh(jawGeo, jawMat);
      jaw.position.set(0, -0.55, 0);
      jaw.geometry.translate(0, 0.15, 0);
      scene.add(jaw);
      // Lights
      const amb = new THREE.AmbientLight(0xffffff, 0.6);
      scene.add(amb);
      const dir = new THREE.DirectionalLight(0xffffff, 0.6);
      dir.position.set(5,5,5);
      scene.add(dir);
      // Animate
      function animate() {
        requestAnimationFrame(animate);
        headMesh.rotation.y += 0.005;
        renderer.render(scene, camera);
      }
      animate();
    });
  }, []);

  const handleLogout = async () => {
    await logoutUser();
    localStorage.removeItem('token');
    navigate('/login');
  };

  if (error) return <div className="error advanced-error">{error}</div>;
  if (!profile) return <div className="dashboard-loading">Loading...</div>;

  return (
    <div className="visa-dashboard-bg">
      <div className="visa-dashboard-card">
        <header className="visa-dashboard-header">
          <div>
            <h1>Visa Interview Demo <span className="visa-brand">by Twelve IT Solutions</span></h1>
            <div className="visa-dashboard-user">Welcome, <b>{profile.display_name || profile.email}</b></div>
          </div>
          <button className="visa-logout-btn" onClick={handleLogout}>Logout</button>
        </header>
        <div className="visa-dashboard-content">
          <div className="visa-avatar-section">
            <h2>3D Interview Avatar</h2>
            <div ref={avatarRef} className="visa-avatar-canvas"></div>
          </div>
          <div className="visa-elevenlabs-section">
            <h2>AI Voice Area</h2>
            <div className="visa-elevenlabs-widget">
              <div style={{marginBottom: '16px', color: '#2f7bff', fontWeight: 600, fontSize: '1.08rem'}}>
                To start your interview, click on <b>Start a call</b> in the widget below.
              </div>
              <elevenlabs-convai ref={widgetRef} agent-id="agent_3201k6hza3sgfkkbny0hya1sm2z8"></elevenlabs-convai>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
